import axios from 'axios'

//采摘批次任务列表(PC)
export function getPickTaskList (data) {
  return axios.get(`/manage/picking-batch-task/list`, { params: data })
}

//取消采摘批次任务
export function cancelPickTask (data) {
  return axios.post(`/manage/picking-batch-task/cancel`, data)
}


//获取采摘批次任务详细信息
export function getPickTask (id) {
  return axios.get(`/manage/picking-batch-task/${id}`)
}

